
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTaskChangeRequestDtoFormGroup() {
return new FormGroup({
    taskId: new FormControl<number | undefined>(undefined, [Validators.required]),
    fieldName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    oldValue: new FormControl<string | undefined>(''),
    newValue: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      